import Swal from "sweetalert2";
import { UserService } from "../../services/User";
import { useState } from "react";

const ChangePasswordModal = () => {
    const [formData, setFormData] = useState({
        password: "",
        password_confirmation: "",
        password_old: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        Swal.showLoading();
        try {

            const response = await UserService().changePassword(formData);
            Swal.fire({
                title: "",
                text: response.data.message,
                icon: "success",
                timer: 1000
            });

        } catch (e) {
            Swal.fire({
                title: "",
                text: e.response.data.message,
                icon: "error"
            });
        }
        Swal.hideLoading();
    };


    return (<>
        <div className="mb-4">
            <label className="block text-gray-700 mb-2">Senha atual</label>
            <input type="password" name="password_old" onChange={handleChange} placeholder="Digite sua senha atual"
                className="w-full p-2 border border-gray-300 rounded-lg" />
        </div>
        <div className="mb-4">
            <label className="block text-gray-700 mb-2">Nova senha</label>
            <input type="password" name="password" onChange={handleChange} placeholder="Digite sua nova senha"
                className="w-full p-2 border border-gray-300 rounded-lg" />
        </div>
        <div className="mb-4">
            <label className="block text-gray-700 mb-2">Confirmar nova senha</label>
            <input type="password" name="password_confirmation" onChange={handleChange} placeholder="Confirme sua nova senha"
                className="w-full p-2 border border-gray-300 rounded-lg" />
        </div>
        <button onClick={handleSubmit} className="btn-primary w-full py-2 px-4 text-white font-medium rounded-lg">
            <i className="fas fa-key mr-2"></i> Alterar senha
        </button>
    </>);
};

export default ChangePasswordModal;